// Formats
// https://date-fns.org/v2.0.1/docs/format

export const DATE_CALENDAR_FORMAT_WITHOUT_TIME = 'MMMM d, yyyy';
export const DATE_CALENDAR_FORMAT_WITH_TIME = `${DATE_CALENDAR_FORMAT_WITHOUT_TIME} p`;
export const DATE_CALENDAR_FORMAT_WITH_ONLY_TIME = `p`;
